import { HeroSection } from '@/components/sections/HeroSection'
import { FeaturedProjects } from '@/components/sections/FeaturedProjects'
import { RecentBlog } from '@/components/sections/RecentBlog'
import { useSeo } from '@/hooks/useSeo'

export function HomePage() {
  useSeo()
  return (
    <>
      <HeroSection />
      <FeaturedProjects />
      <RecentBlog />
    </>
  )
}
